<template>
  <div class="px-5">
    <v-data-table
      no-data-text="Não há dados"
      :headers="headers"
      :items="accountsList"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.account_name }}
          <br />
        </td>
        <td class="text-xs-left">{{props.item.type_account.toUpperCase()}}</td>
        <td class="text-xs-left">R$ {{ props.item.account_value }}</td>
        <td class="text-xs-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" flat icon @click="editLine(props.item)">
                <v-icon small>edit</v-icon>
              </v-btn>
            </template>
            <span>Editar conta</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" flat icon @click="openDialogForm(props.item)">
                <v-icon small>cloud_upload</v-icon>
              </v-btn>
            </template>
            <span>Enviar arquivos</span>
          </v-tooltip>
          <!-- <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> -->
        </td>
      </template>
    </v-data-table>
    <UploadFinancialsFile
      :financialUploadMode="financialUploadMode"
      :hideOpenButton="true"
      :dialog="uploadDialog"
      :openForm="() => openDialogForm('upLoad')"
      :closeForm="() => closeDialogForm('upLoad')"
      :sendFile="(data) => sendFile(data)"
      :editFormData="formData"
    />
  </div>
</template>
<script>
import axios from 'axios'
import UploadFinancialsFile from '../../common/UploadFile'
export default {
  components: { UploadFinancialsFile },
  props: {
    accountsList: Array,
    editAccountLine: Function
  },
  methods: {
    closeDialogForm () {
      this.uploadDialog = false
    },
    openDialogForm (data) {
      this.financial_id = data.financial_id
      this.account_id = data.id
      this.uploadDialog = true
      // alert("upload");
    },
    sendFile (data) {
      // api/document/uploadfiles
      let USER_TOKEN = localStorage.getItem('token')
      let AuthStr = 'Bearer '.concat(USER_TOKEN)
      let formData = new FormData()

      let urlList = {
        budget: '/api/budget',
        realized: '/api/realized'
      }

      let url = urlList[data.financialType]
      data.financial_id = this.financial_id
      data.account_id = this.account_id
      for (var key in data) {
        formData.append(key, data[key])
      }
      // console.log(formData);
      // return;
      this.$store.commit('showLoader', {
        circle: true
      })
      axios.defaults.baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL
          : process.env.VUE_APP_API_URL_DEV
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: AuthStr
          }
        })
        .then(resp => {
          this.$store.commit('hideLoader')
          let obj = {
            message: 'Upload realizado com sucesso!',
            title: 'Sucesso',
            callback: _ => {
              this.uploadDialog = false
              // this.initialize();
            },
            type: 'success',
            btConfirm: { name: 'Fechar', show: true },
            btCancel: { name: 'Fechar', show: false }
          }
          this.$store.commit('confirmMessage/showConfirmMessage', obj)
        })
        .catch(error => {
          let paramModal = {}
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join('<br>')
              : error.response.data.message
            : 'Contate o administrador do sistema'
          paramModal.title = 'Ocorreu erro'
          paramModal.type = 'error'
          paramModal.callback = null
          paramModal.btConfirm = {
            name: 'Ok',
            show: true
          }
          paramModal.btCancel = {
            show: false
          }
          this.$store.commit('hideLoader')
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
        })
    },
    editLine (data) {
      this.editAccountLine(data)
    }
  },
  data () {
    return {
      account_id: '',
      financial_id: '',
      financialUploadMode: true,
      uploadDialog: false,
      formData: {},
      headers: [
        {
          text: 'Nome da conta',
          align: 'left',
          sortable: false,
          value: 'account_name'
        },
        {
          text: 'Tipo da conta',
          align: 'left',
          sortable: false,
          value: 'type_account'
        },
        {
          text: 'Valor da conta',
          align: 'left',
          sortable: false,
          value: 'account_value'
        },
        {
          text: 'Ações',
          align: 'center',
          sortable: false,
          value: 'acions'
        }
      ]
    }
  }
}
</script>

<style>
</style>
